import axios from 'axios'
import { API_URL, CSRF_COOKIE } from '../config'

/**
 * Cliente HTTP de la API. Sesión de Django por cookie (`withCredentials`) y token
 * CSRF en X-CSRFToken: axios lo lee de la cookie `<slug>_csrftoken` en cada request
 * del mismo origen (la API vive bajo el mismo host que el SPA). La cookie la deja
 * el backend en GET /api/info/ y /api/me/, que el SPA pide al arrancar.
 *
 * Sin Content-Type fijo: axios pone application/json a los objetos y deja que el
 * navegador arme el multipart (con su boundary) cuando el cuerpo es un FormData.
 */
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { Accept: 'application/json' },
  xsrfCookieName: CSRF_COOKIE,
  xsrfHeaderName: 'X-CSRFToken',
})

/** Se llama cuando una petición responde 401: la sesión venció en el servidor. */
let alPerderSesion: (() => void) | null = null
export function registrarPerdidaDeSesion(fn: () => void) {
  alPerderSesion = fn
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    // me/ y login/ responden 401 como parte de su trabajo (sin sesión, clave mala).
    const url = error.config?.url ?? ''
    if (status === 401 && !url.startsWith('me/') && !url.startsWith('login/')) alPerderSesion?.()
    return Promise.reject(error)
  },
)

export default api
